let audioContext = null
let lastPlayedAt = 0
let queuedNotification = false

function getAudioContext() {
  if (audioContext || typeof window === 'undefined') {
    return audioContext
  }
  const AudioContext = window.AudioContext || window.webkitAudioContext
  if (!AudioContext) {
    return null
  }
  audioContext = new AudioContext()
  return audioContext
}

export function unlockNotificationAudio() {
  const context = getAudioContext()
  if (!context) {
    return Promise.resolve(false)
  }
  const resumePromise = context.state === 'suspended'
    ? context.resume().catch(() => false)
    : Promise.resolve(true)
  return resumePromise.then(() => {
    if (context.state !== 'running') {
      return false
    }
    if (queuedNotification) {
      queuedNotification = false
      playNotificationTones(context)
    }
    return true
  })
}

function playTone(context, frequency, startAt, duration) {
  const oscillator = context.createOscillator()
  const gain = context.createGain()
  oscillator.type = 'sine'
  oscillator.frequency.setValueAtTime(frequency, startAt)
  gain.gain.setValueAtTime(0.0001, startAt)
  gain.gain.exponentialRampToValueAtTime(0.18, startAt + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration)
  oscillator.connect(gain)
  gain.connect(context.destination)
  oscillator.start(startAt)
  oscillator.stop(startAt + duration)
}

function playNotificationTones(context) {
  const startAt = context.currentTime + 0.02
  playTone(context, 880, startAt, 0.18)
  playTone(context, 1174.66, startAt + 0.16, 0.24)
}

export function playNotificationSound() {
  const now = Date.now()
  if (now - lastPlayedAt < 800) {
    return Promise.resolve(false)
  }
  lastPlayedAt = now
  const context = getAudioContext()
  if (!context) {
    return Promise.resolve(false)
  }
  if (context.state === 'running') {
    playNotificationTones(context)
    return true
  }
  queuedNotification = true
  return unlockNotificationAudio().then(unlocked => {
    return unlocked && !queuedNotification
  }).catch(() => false)
}



// WEBPACK FOOTER //
// ./src/utils/adminNotificationSound.js